import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

interface BarcodeProps {
  value: string;
}

const Barcode: React.FC<BarcodeProps> = ({ value }) => {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (svgRef.current && value) {
      JsBarcode(svgRef.current, value, {
        format: 'CODE128',
        lineColor: '#000',
        width: 2,
        height: 40,
        displayValue: false,
      });
    }
  }, [value]);

  // Download barcode as PNG
  const downloadBarcode = () => {
    if (!svgRef.current) return;

    const svg = svgRef.current;
    const svgData = new XMLSerializer().serializeToString(svg);

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    // Set canvas size same as SVG size
    const bbox = svg.getBBox();
    canvas.width = bbox.width;
    canvas.height = bbox.height;

    img.onload = () => {
      ctx?.clearRect(0, 0, canvas.width, canvas.height);
      ctx?.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');

      const downloadLink = document.createElement('a');
      downloadLink.href = pngFile;
      downloadLink.download = `${value}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };

    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <svg ref={svgRef} />
      <button
        style={{
          cursor: 'pointer',
          padding: '4px 8px',
          fontSize: 12,
          borderRadius: 4,
          border: '1px solid #ccc',
          backgroundColor: '#f0f0f0',
        }}
        onClick={downloadBarcode}
        aria-label="Download barcode"
        title="Download barcode"
      >
        Download
      </button>
    </div>
  );
};

export default Barcode;
